"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React from "react";
import WaitingSpinner from "../../components/waiting_spinner";
import Api from "../../api/api";
import {
  CARRIER_INVOICE_MODEL_OBJECT_TYPE,
  FACTOR_INVOICE_MODEL_OBJECT_TYPE,
  LOAD_SHIPMENT_MODEL_OBJECT_TYPE
} from "../../api/exception_events";
import { CarrierInvoice } from "../domain/carrier_invoice";
import { LoadShipment } from "../domain/load_shipment";
import Notification from "../../components/notification";
import NotificationCTAButton from "../../components/notification_cta_button";
import { LoadState } from "../domain/load_state";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
import { Notification as NotificationV3 } from "../ui/v3/notification";
function carrierInvoiceModel(props) {
  return new CarrierInvoice(props.carrierInvoice, new LoadState(props.load));
}
function loadShipmentModel(props) {
  return new LoadShipment(props.loadShipment);
}
function modelObjectIsApprovedAndUnapprovable(props) {
  if (modelObjectType(props) === CARRIER_INVOICE_MODEL_OBJECT_TYPE)
    return carrierInvoiceModel(props).isPayableApproved() && carrierInvoiceModel(props).unapprovingPayableAllowed();
  else if (modelObjectType(props) === LOAD_SHIPMENT_MODEL_OBJECT_TYPE)
    return loadShipmentModel(props).isApproved() && loadShipmentModel(props).unapprovingAllowed();
  else
    return false;
}
function modelObject(props) {
  const objectLookup = {};
  objectLookup[LOAD_SHIPMENT_MODEL_OBJECT_TYPE] = props.loadShipment;
  objectLookup[CARRIER_INVOICE_MODEL_OBJECT_TYPE] = props.carrierInvoice;
  objectLookup[FACTOR_INVOICE_MODEL_OBJECT_TYPE] = props.factorInvoice;
  return objectLookup[modelObjectType(props)];
}
function modelObjectType(props) {
  if (props.loadShipment) return LOAD_SHIPMENT_MODEL_OBJECT_TYPE;
  else if (props.carrierInvoice) return CARRIER_INVOICE_MODEL_OBJECT_TYPE;
  else return FACTOR_INVOICE_MODEL_OBJECT_TYPE;
}
const UnapproveBanner = React.createClass({
  getInitialState: function() {
    return {};
  },
  render: function() {
    if (this.props.v3ReskinEnabled) return this.renderV3Reskin();
    if (!modelObjectIsApprovedAndUnapprovable(this.props)) return null;
    const permissions = carrierInvoiceModel(this.props).unapprovalPermissions();
    const message = (() => {
      if (permissions.userCanUnapprove)
        return "To make changes, please unapprove.";
      else if (permissions.adminCanUnapprove)
        return "To make changes, please contact your team's TriumphPay Audit administrator.";
      else
        return "No further changes are permitted. To make changes, please contact support.";
    })();
    const supportEmail = Api.Account.processorSupportEmailAddress();
    const supportUrl = supportEmail ? `mailto:${supportEmail}` : "https://paymentshelp.triumph.io/support/tickets/new";
    const target = supportEmail ? void 0 : "_blank";
    const action = /* @__PURE__ */ React.createElement("div", null, permissions.userCanUnapprove && /* @__PURE__ */ React.createElement(NotificationCTAButton, { onClick: this.startUnapprove }, "Unapprove"), permissions.unapprovalsNotAllowed && /* @__PURE__ */ React.createElement(
      "a",
      {
        className: "unapprove_banner--link",
        href: supportUrl,
        target
      },
      "Contact Support"
    ));
    return /* @__PURE__ */ React.createElement("div", { className: "mb-3", "data-component": "UnapproveBanner" }, /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.unapproving }, /* @__PURE__ */ React.createElement(
      Notification,
      {
        type: "info",
        title: "Status: Approved",
        body: message,
        action
      }
    )));
  },
  renderV3Reskin: function() {
    if (!modelObjectIsApprovedAndUnapprovable(this.props)) return null;
    const permissions = carrierInvoiceModel(this.props).unapprovalPermissions();
    const message = (() => {
      if (permissions.userCanUnapprove)
        return "To make changes, please unapprove.";
      else if (permissions.adminCanUnapprove)
        return "To make changes, please contact your team's TriumphPay Audit administrator.";
      else
        return "No further changes are permitted. To make changes, submit a ticket.";
    })();
    const supportEmail = Api.Account.processorSupportEmailAddress();
    const supportUrl = supportEmail ? `mailto:${supportEmail}` : "https://paymentshelp.triumph.io/support/tickets/new";
    const target = supportEmail ? void 0 : "_blank";
    const action = (() => {
      if (permissions.userCanUnapprove) {
        return /* @__PURE__ */ React.createElement(
          Button,
          {
            size: ButtonSize.Small,
            variant: ButtonVariant.Text,
            disabled: this.state.unapproving,
            onClick: this.startUnapprove
          },
          this.state.unapproving ? "Unapproving" : "Unapprove"
        );
      } else if (permissions.unapprovalsNotAllowed) {
        return /* @__PURE__ */ React.createElement(
          Button,
          {
            size: ButtonSize.Small,
            variant: ButtonVariant.Text,
            href: supportUrl,
            target
          },
          "Create ticket"
        );
      }
    })();
    return /* @__PURE__ */ React.createElement(NotificationV3, { title: "Approved", message, action });
  },
  startUnapprove: function() {
    return __async(this, null, function* () {
      this.setState({ unapproving: true });
      const promise = (() => {
        if (modelObjectType(this.props) === CARRIER_INVOICE_MODEL_OBJECT_TYPE)
          return Api.CarrierInvoices.unApprove(modelObject(this.props).id);
        else if (modelObjectType(this.props) === LOAD_SHIPMENT_MODEL_OBJECT_TYPE)
          return Api.LoadShipments.unApprove(
            modelObject(this.props).id,
            this.props.carrierInvoice.id
          );
        else return Promise.resolve(null);
      })();
      try {
        yield promise;
      } catch (e) {
      } finally {
        this.setState({ unapproving: false });
      }
    });
  }
});
export default UnapproveBanner;
